import React, { Component, ErrorInfo, ReactNode } from 'react';
import { Button, Card } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
  errorInfo: ErrorInfo | null;
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
      errorInfo: null,
    };
  }

  static getDerivedStateFromError(error: Error): State {
    return {
      hasError: true,
      error,
      errorInfo: null,
    };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('ErrorBoundary 捕获到错误:', error, errorInfo);
    this.setState({
      error,
      errorInfo,
    });
  }

  handleReset = () => {
    this.setState({
      hasError: false,
      error: null,
      errorInfo: null,
    });
  };

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return this.props.fallback;
      }

      return (
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          padding: 'var(--spacing-lg)',
          background: 'var(--color-bg-primary)'
        }}>
          <Card
            title="出现错误"
            style={{ maxWidth: '600px', width: '100%' }}
            extra={
              <Button
                icon={<ReloadOutlined />}
                onClick={this.handleReset}
                type="primary"
              >
                重试
              </Button>
            }
          >
            <div style={{ marginBottom: 'var(--spacing-md)' }}>
              <p style={{ color: 'var(--color-error)', marginBottom: 'var(--spacing-sm)' }}>
                {this.state.error?.message || '发生了未知错误'}
              </p>
              {process.env.NODE_ENV === 'development' && this.state.errorInfo && (
                <details style={{ marginTop: 'var(--spacing-md)' }}>
                  <summary style={{ cursor: 'pointer', color: 'var(--color-text-secondary)' }}>
                    错误详情
                  </summary>
                  <pre style={{
                    marginTop: 'var(--spacing-sm)',
                    padding: 'var(--spacing-sm)',
                    background: 'var(--color-bg-secondary)',
                    borderRadius: 'var(--border-radius-md)',
                    overflow: 'auto',
                    fontSize: '12px',
                    color: 'var(--color-text-primary)'
                  }}>
                    {this.state.error?.stack}
                    {'\n\n'}
                    {this.state.errorInfo.componentStack}
                  </pre>
                </details>
              )}
            </div>
            <Button
              type="default"
              onClick={() => window.location.reload()}
              style={{ width: '100%' }}
            >
              刷新页面
            </Button>
          </Card>
        </div>
      );
    }

    return this.props.children;
  }
}

